import {
  DelayedLowLimitIcon,
  DelayedHighLimitIcon,
  AdjustmentCertificateIcon,
  CriticalAlarmIcon,
  HighLimitIcon,
  LowLimitIcon,
  CommentSlashIcon,
  DataloggingIcon,
  UnlinkIcon,
  InfoIcon,
  SkullIcon,
} from 'src/components/common/icons'
import { TimesIcon, ExclamationIcon } from 'labguard-cdk'

export const alarmTypes = {
  HIGH_LIMIT_EXCEEDED: {
    i18n: 'WEB_HIGH_LIMIT_EXCEEDED',
    icon: HighLimitIcon,
  },
  LOW_LIMIT_EXCEEDED: {
    i18n: 'WEB_LOW_LIMIT_EXCEEDED',
    icon: LowLimitIcon,
  },
  DELAYED_HIGH_LIMIT_EXCEEDED: {
    i18n: 'WEB_DELAYED_HIGH_LIMIT_EXCEEDED',
    icon: DelayedHighLimitIcon,
  },
  DELAYED_LOW_LIMIT_EXCEEDED: {
    i18n: 'WEB_DELAYED_LOW_LIMIT_EXCEEDED',
    icon: DelayedLowLimitIcon,
  },
  NO_RESPONSE: {
    i18n: 'WEB_NO_RESPONSE',
    icon: CommentSlashIcon,
  },
  DATALOGGING_RETRIEVAL_FAILURE: {
    i18n: 'WEB_DATALOGGING_RETRIEVAL_FAILURE',
    icon: DataloggingIcon,
  },
  EXPIRED_ADJUSTMENT: {
    i18n: 'WEB_EXPIRED_ADJUSTMENT',
    icon: AdjustmentCertificateIcon,
  },
  SERVICE_DOWN: {
    i18n: 'WEB_ALERT_SERVICE_DOWN',
  },
  COMMUNICATION_LOST: {
    i18n: 'WEB_ALERT_COMMUNICATION_LOST',
  },
  NETWORK_MODIFICATION: {
    i18n: 'WEB_ALERT_NETWORK_MODIFICATION',
  },
  CONFIGURATION_MODIFICATION: {
    i18n: 'WEB_ALERT_CONFIGURATION_MODIFICATION',
  },
  CALIBRATION_ABOUT_TO_EXPIRE: {
    i18n: 'WEB_CALIBRATION_ABOUT_TO_EXPIRE',
  },
  MAPPING_ENDED: {
    i18n: 'WEB_MAPPING_ENDED',
  },
  MODEM_OVERLOAD: {
    i18n: 'WEB_MODEM_OVERLOAD',
  },
  CONNECTION_LOST_REPLICATION: {
    i18n: 'WEB_CONNECTION_LOST_REPLICATION',
  },
  ALT_DEVICE_NOT_WORKING: {
    i18n: 'WEB_ALT_DEVICE_NOT_WORKING',
  },
  ALT_ALL_DEVICES_NOT_WORKING: {
    i18n: 'WEB_ALT_ALL_DEVICES_NOT_WORKING',
  },
  ACQ_BACKUP_CHECK_FAILED: {
    i18n: 'WEB_ACQ_BACKUP_CHECK_FAILED',
  },
  ACQ_SET_CONFIG_FAILED: {
    i18n: 'WEB_ACQ_SET_CONFIG_FAILED',
  },
  SYSTEM_DATETIME_MODIFICATION: {
    i18n: 'WEB_SYSTEM_DATETIME_MODIFICATION',
  },
  SYSTEM_DATETIME_MINOR_MODIFICATION: {
    i18n: 'WEB_SYSTEM_DATETIME_MINOR_MODIFICATION',
  },
  DATABASE_SAVE_FAILED: {
    i18n: 'WEB_DATABASE_SAVE_FAILED',
  },
  DATABASE_SAVE_SUCCEED: {
    i18n: 'WEB_DATABASE_SAVE_SUCCEED',
  },
  CRC_ERROR: {
    i18n: 'WEB_CRC_ERROR',
  },
  SENSOR_LIMIT_RAISED: {
    i18n: 'WEB_SENSOR_LIMIT_RAISED',
  },
  INTRUSION_ATTEMPT: {
    i18n: 'WEB_INTRUSION_ATTEMPT',
  },
  FAILED_TO_SET_RELAY: {
    i18n: 'WEB_FAILED_TO_SET_RELAY',
  },
  LG3_MEMORY_FULL: {
    i18n: 'WEB_LG3_MEMORY_FULL',
  },
  LG3_BATTERY_LEVEL: {
    i18n: 'WEB_LG3_BATTERY_LEVEL',
  },
  LG3_MAIN_POWER_SUPPLY: {
    i18n: 'WEB_LG3_MAIN_POWER_SUPPLY',
  },
  DAYLIGHT_SAVING_TIME: {
    i18n: 'DAYLIGHT_SAVING_TIME',
  },
  SENSOR_MEMORY_ISSUE: {
    i18n: 'WEB_SENSOR_MEMORY_ISSUE',
  },
}

export const alarmCriticalities = {
  FATAL: { value: 1, color: '#b0b0b0', icon: SkullIcon, i18n: 'WEB_FATAL_ERROR' },
  CRITICAL: { value: 1, color: '#6699ff', icon: CriticalAlarmIcon, i18n: 'WEB_CRITICAL_ERROR' },
  MAJOR: { value: 2, color: '#b181de', icon: UnlinkIcon, i18n: 'WEB_MAJOR_ERROR' },
  MINOR: { value: 3, color: 'danger', icon: TimesIcon, i18n: 'WEB_MINOR_ERROR' },
  WARNING: { value: 4, color: 'warning', icon: ExclamationIcon, i18n: 'WEB_WARNING' },
  INFO: { value: 5, color: 'secondary', icon: InfoIcon, i18n: 'WEB_INFO' },
}
